// Shared people helpers. Names are stored as "Cognome Nome"; display/sort are presentational only.
const collator = new Intl.Collator("it", { sensitivity: "base", numeric: true });

export function sortByName(list, getName = (x) => x.name || "") {
  return [...(list || [])].sort((a, b) => collator.compare(getName(a), getName(b)));
}

// mode: "full" keeps the full name; "medium" keeps the surname and initials the rest.
export function shortName(name, mode = "full") {
  const n = (name || "").trim();
  if (mode === "full" || !n) return n;
  const parts = n.split(/\s+/);
  if (parts.length < 2) return n;
  const [surname, ...rest] = parts;
  return `${surname} ${rest.map((w) => (w[0] || "").toUpperCase() + ".").join(" ")}`;
}
